import { cloneEdges, cloneNodes } from '../documentClone.js';
import type { EditorCommand } from '../commandBuilders.js';
import type { AppState } from '../../state/appState.js';
import type { GeometrySlot, MaterialSlot } from '../../scene/layerState.js';

export function currentInlineSlotValueFor(appState: AppState, _slot: 'geometry' | 'material'): GeometrySlot | MaterialSlot {
  return {
    type: 'inline',
    nodes: cloneNodes(appState.nodes),
    edges: cloneEdges(appState.edges),
  };
}

export function isGraphStructureEdit(cmd: EditorCommand): boolean {
  switch (cmd.type) {
    case 'graph:createNode':
    case 'graph:deleteNode':
    case 'graph:moveNode':
    case 'graph:setData':
    case 'graph:connect':
    case 'graph:reconnect':
    case 'graph:cutEdges':
      return true;
    default:
      return false;
  }
}

export function createForkedLibraryNameFor(
  appState: AppState,
  kind: 'geometry' | 'material',
  baseName: string,
): string {
  const lib = kind === 'geometry' ? appState.geometryLibrary
    : appState.materialLibrary;
  const names = new Set([
    ...Object.values(lib.builtIn).map(item => item.name),
    ...Object.values(lib.user).map(item => item.name),
  ]);
  const copyName = `${baseName} Copy`;
  if (!names.has(copyName)) return copyName;

  let index = 2;
  while (names.has(`${baseName} Copy ${index}`)) {
    index += 1;
  }
  return `${baseName} Copy ${index}`;
}

export function getLibraryStoreFor(appState: AppState, kind: 'geometry' | 'material') {
  return kind === 'geometry' ? appState.geometryLibrary.user : appState.materialLibrary.user;
}
